import { render, staticRenderFns } from "./DetailGrid.vue?vue&type=template&id=e5edd620&scoped=true&"
import script from "./DetailGrid.vue?vue&type=script&lang=js&"
export * from "./DetailGrid.vue?vue&type=script&lang=js&"
import style0 from "./DetailGrid.vue?vue&type=style&index=0&id=e5edd620&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5edd620",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5edd620')) {
      api.createRecord('e5edd620', component.options)
    } else {
      api.reload('e5edd620', component.options)
    }
    module.hot.accept("./DetailGrid.vue?vue&type=template&id=e5edd620&scoped=true&", function () {
      api.rerender('e5edd620', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/statistics/durginfo-stast-view/grid/DetailGrid.vue"
export default component.exports